// Quais módulos a loja deixou ligados (Configurações → Sistema → Preferências →
// "Módulos da loja", pedido do dono 29/09/2026). O Dashboard usa para esconder
// do cabeçalho e do menu o módulo desligado (Mesas, Comandas, Balcão, Totem,
// Delivery). Enquanto carrega, ou com erro, tudo fica ligado (como sempre foi).
// O cartão de Preferências avisa a mudança pelo evento EVENTO_MODULOS, e a tela
// atualiza na hora, sem recarregar.
import { useCallback, useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
export const EVENTO_MODULOS = "nucleo:modulos-loja";

export function useModulosLoja(ativo = true) {
  const [desligados, setDesligados] = useState([]);
  useEffect(() => {
    if (!ativo) return undefined;
    let vivo = true;
    fetch(`${API_URL}/api/settings/modulos`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` }, cache: "no-store",
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (vivo && Array.isArray(d?.desligados)) setDesligados(d.desligados); })
      .catch(() => {});
    const mudou = (e) => { if (Array.isArray(e.detail?.desligados)) setDesligados(e.detail.desligados); };
    window.addEventListener(EVENTO_MODULOS, mudou);
    return () => { vivo = false; window.removeEventListener(EVENTO_MODULOS, mudou); };
  }, [ativo]);
  const ligado = useCallback((modulo) => !desligados.includes(modulo), [desligados]);
  return { desligados, ligado };
}
